(function () {
  window.vsGalleryObserver = window.vsGalleryObserver || null;

  const initProductGalleryCounter = () => {
    const carousel = document.querySelector(".product-gallery__carousel");
    const allMedia = document.querySelectorAll(".product-gallery__media");

    if (!carousel || allMedia.length === 0) return;

    const filteredMedia = Array.from(allMedia).filter((el) => {
      // On variant change the theme hides media via the `hidden` attribute
      // (scroll-carousel.filter() -> cell.toggleAttribute("hidden", ...)), not a class.
      // The initial server-side render also sets `hidden` plus the [.js_&]:tw-hidden class.
      const isHiddenAttr = el.hasAttribute("hidden");
      const isHiddenClass =
        el.classList.contains("tw-hidden") ||
        el.classList.contains("[.js_&]:tw-hidden");
      const isOpacityZero = window.getComputedStyle(el).opacity === "0";
      return !isHiddenAttr && !isHiddenClass && !isOpacityZero;
    });

    const total = filteredMedia.length;
    if (total === 0) return;

    let counterDisplay = document.querySelector(".wr-gallery-counter");
    if (!counterDisplay) {
      counterDisplay = document.createElement("div");
      counterDisplay.className = "wr-gallery-counter";
      carousel.parentElement.style.position = "relative";
      carousel.parentElement.appendChild(counterDisplay);
    }

    if (window.vsGalleryObserver) {
      window.vsGalleryObserver.disconnect();
    }

    const observerOptions = {
      root: carousel,
      threshold: 0.6,
    };

    window.vsGalleryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const currentIndex = filteredMedia.indexOf(entry.target) + 1;
          counterDisplay.textContent = `${currentIndex} / ${total}`;
        }
      });
    }, observerOptions);

    filteredMedia.forEach((el) => window.vsGalleryObserver.observe(el));
  };

  const observeNavigation = () => {
    let lastUrl = location.href;

    const mutationObserver = new MutationObserver(() => {
      const currentUrl = location.href;
      const carousel = document.querySelector(".product-gallery__carousel");

      if (
        currentUrl !== lastUrl ||
        (carousel && !carousel.dataset.vsCounterInit)
      ) {
        lastUrl = currentUrl;

        if (carousel) {
          carousel.dataset.vsCounterInit = "true";
          setTimeout(initProductGalleryCounter, 600);
        }
      }
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  };

  observeNavigation();
  initProductGalleryCounter();

  // Recalculate when the variant changes even if the URL doesn't update. The theme applies its
  // media filter (toggling the `hidden` attribute) synchronously on this event, so we defer a
  // couple of frames to read the final visible set.
  document.addEventListener(
    "variant:change",
    () => {
      requestAnimationFrame(() =>
        requestAnimationFrame(initProductGalleryCounter)
      );
    },
    { passive: true }
  );
})();
